import Vue from 'vue'
import { Module, ActionContext } from 'vuex'
import { RootState, AdPublishingState } from './state_models'
import { company } from './company'
import AdPublishingService from '../services/AdPublishingService'
import { AD_PUBLISHING_CONNECT_BM_LOCATION, AD_PUBLISHING_STANDARD_PLAN } from '../util/constants'
import store from '.'

export const adPublishing: Module<AdPublishingState, RootState> = {
  namespaced: true,
  state: { adPublishingLocationConfig: {} },
  getters: {
    getForLocation: (state: AdPublishingState) => {
      return () => state.adPublishingLocationConfig
    },
  },
  mutations: {
    set: (state: AdPublishingState, payload: { adPublishingLocationConfig?: { [key: string]: any } }) => {
      state.adPublishingLocationConfig = payload.adPublishingLocationConfig || {}
    },
  },
  actions: {
    async syncAll(context: ActionContext<AdPublishingState, RootState>, locationId: string) {
      if (!locationId) {
        return
      }
      try {
        // try fetching company if the store is not set
        if (!company.state.company?.id) {
          // if available it returns the state context else it fetches from the server
          await store.dispatch('company/get')
        }
        const companyId = company?.state?.company?.id
        if (!companyId) return
        // if both standard and cyobm plan are not subscribed for location then check for company subscription
        const cyobmCompanySub = await AdPublishingService.getCompanySubscription(companyId)
        let planName = AD_PUBLISHING_STANDARD_PLAN
        if (cyobmCompanySub.subscribed) {
          // if company is subscribed then check if location subscription is present for Standard plan
          const locSubscription = await AdPublishingService.getLocationSubscription(
            locationId,
            AD_PUBLISHING_STANDARD_PLAN
          )
          if (locSubscription.subscribed) {
            planName = AD_PUBLISHING_STANDARD_PLAN
          } else {
            planName = AD_PUBLISHING_CONNECT_BM_LOCATION
          }
        }
        const locationConfiguration = await AdPublishingService.getLocationConfiguration(locationId, planName)
        context.commit('set', {
          adPublishingLocationConfig: { ...locationConfiguration, locPlan: planName },
        })
      } catch (err) {
        return
      }
    },
  },
}
